import { Type } from "@shared/ui/Type";
import { Loader } from "@shared/ui/Loader";

export function VideoUILoading() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[100dvh] gap-4">
      <div>
        <Type variant="h4">Verifying Access...</Type>
        <Loader />
      </div>
    </div>
  );
}

export default VideoUILoading;
